// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__3n8bA","configuration":"styles_configuration__2Ts3h","pricing":"styles_pricing__XSoC7"};